<template>
  <div class="sharePayDialog">
    <el-dialog
      class="sharePayDialog_dialog"
      title="扫码支付"
      :visible.sync="visible"
      width="460px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="close">
      <div class="content">
        <div class="status">需付款</div>
        <div class="price">
          <div class="price_icon">￥</div>
          <div class="price_text">{{ price }}</div>
        </div>
        <div class="tips">请使用微信扫码支付</div>
        <div class="qrcode">
          <div ref="qrcode" class="qrcode_img"></div>
        </div>
        <el-button class="btn_close" @click="close">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import QRCode from 'qrcodejs2'
  export default {
    name: 'sharePayDialog',
    data () {
      return {
        visible: false,
        qrcode: null,
        price: '',
        orderId: ''
      }
    },
    methods: {
      // 生成二维码
      crateQrcode () {
        this.qrcode = new QRCode(this.$refs['qrcode'], {
          width: 240,
          height: 240,
          text: `${process.env.VUE_APP_API_URL}/sharePay?orderId=${this.orderId}`
        });
      },
      open (info) {
        this.visible = true
        this.orderId = info.orderId
        this.price = info.price
        this.$nextTick(() => {
          this.crateQrcode()
        })
      },
      close () {
        this.price = ''
        this.orderId = ''
        this.$refs['qrcode'].innerHTML = '';
        this.visible = false
      }
    }
  }
</script>

<style lang="less" scoped>
  .sharePayDialog_dialog /deep/ .el-dialog {
    border-radius: 4px;
  }
  .sharePayDialog_dialog /deep/ .el-dialog__header {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 24px;
    height: 48px;
    border-bottom: 1px solid #EBEAEE !important;
  }

  .sharePayDialog_dialog /deep/ .el-dialog__title {
    line-height: 24px;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
  }

  .sharePayDialog_dialog /deep/ .el-dialog__headerbtn {
    top: 16px;
    right: 16px;
  }

  .sharePayDialog_dialog /deep/ .el-dialog__body {
    padding: 0;
  }

  .sharePayDialog_dialog /deep/ .el-dialog__footer {
    padding: 0;
  }

  .content {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 24px 0 32px;
    width: 100%;
    background-color: #FAFBFC;
  }

  .status {
    line-height: 24px;
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }

  .price {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    margin: 4px 0 0 0;
  }

  .price_icon {
    line-height: 24px;
    font-weight: bold;
    font-size: 16px;
    color: #FE8F1F;
  }

  .price_text {
    line-height: 30px;
    font-weight: bold;
    font-size: 24px;
    color: #FE8F1F;
  }

  .tips {
    margin: 4px 0 0 0;
    line-height: 20px;
    font-size: 14px;
    color: #667182;
  }

  .qrcode {
    box-sizing: border-box;
    margin: 16px 0 0 0;
    padding: 10px;
    width: 260px;
    height: 260px;
    background-color: #FFFFFF;
    border-radius: 6px;
  }

  .qrcode_img {
    width: 100%;
    height: 100%;
    background-color: #ECECEC;
    border-radius: 6px;
  }

  .btn_close {
    margin: 24px 0 0 0;
    width: 116px;
  }
</style>